import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/AppLayout";
import { Card } from "@/components/ui/card";
import { MapPin } from "lucide-react";

export default function Territorial() {
  const [provinces, setProvinces] = useState([]);

  useEffect(() => { api.get("/territoires").then((r) => setProvinces(r.data)); }, []);

  return (
    <>
      <PageHeader title="Suivi territorial" subtitle="23 délégations provinciales · régime de déconcentration · moteur TERRA" />
      <div className="p-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
          {provinces.map((p) => {
            const name = p.nom.split("— ").pop();
            return (
              <Card key={p.id} className="rounded-sm border-border shadow-none p-4 hover:border-navy transition-colors" data-testid={`province-${p.code}`}>
                <div className="flex items-start justify-between">
                  <div className="flex items-center gap-2">
                    <div className="h-8 w-8 flex items-center justify-center rounded-sm bg-teal-50 text-teal-700">
                      <MapPin className="h-4 w-4" strokeWidth={1.5} />
                    </div>
                    <div>
                      <p className="font-medium text-slate-800 leading-tight">{name}</p>
                      <p className="text-[10px] text-muted-foreground font-mono">{p.code}</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="font-heading text-xl font-bold text-navy">{p.dossiers_ouverts}</p>
                    <p className="text-[10px] text-muted-foreground uppercase">dossiers</p>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </>
  );
}
